// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBKn4CQv88_j7KiYQi-57zfXei4ixbf9bY",
  authDomain: "pubgolf-65868.firebaseapp.com",
  projectId: "pubgolf-65868",
  storageBucket: "pubgolf-65868.firebasestorage.app",
  messagingSenderId: "1041425196740",
  appId: "1:1041425196740:web:eaa43d18726a73dfa50b91"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Export firestore database
// It will be imported into your react app whenever it is needed
export const db = getFirestore(app);